import { useState, useCallback, useMemo, isValidElement } from 'react';
import { type MenuItem, MenuNodeType } from '../../../../../common/types.tsx';
import { useMenuItemCheckOpen } from '../../../../../controllers/context-menu/index.tsx';

type SubmenuPersistentFocusProps = {
	menuItem: MenuItem;
	scope: string;
};

export const useSubmenuPersistentFocus = ({ scope, menuItem }: SubmenuPersistentFocusProps) => {
	const isOpen = useMenuItemCheckOpen({ scope, menuItem });

	const hasSearch = useMemo(() => {
		if (isValidElement(menuItem.element)) {
			return menuItem.element.props.hasSearch;
		}
		const children = Array.isArray(menuItem.children) ? menuItem.children : [menuItem.children];

		return children.some((child) => child?.type === MenuNodeType.Search && child.hasSearch);
	}, [menuItem.element, menuItem.children]);

	const [persistentFocus, setPersistentFocus] = useState(hasSearch);
	const disablePersistentFocus = useCallback(() => {
		if (!hasSearch) {
			setPersistentFocus(false);
		}
	}, [hasSearch]);

	return {
		persistentFocus: persistentFocus && isOpen,
		enablePersistentFocus: () => {
			setPersistentFocus(true);
		},
		disablePersistentFocus,
		isOpen,
	};
};
